import React from 'react';
import Styles from './button-reset-styles.scss';
const ButtonReset = ({ onClick }) => {
    return (React.createElement("button", { onClick: onClick, className: Styles.btnReset }, "Reset"));
};
export default ButtonReset;
